import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import '../styles/CookieBanner.css';

const CookieBanner = () => {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà fait son choix
    const cookieConsent = Cookies.get('cookieConsent');
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set('cookieConsent', 'accepted', { expires: 365 }); // Expire dans 1 an
    setShowBanner(false);
  };

  const handleDecline = () => {
    Cookies.set('cookieConsent', 'declined', { expires: 365 });
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <h3>{t('cookies.title')}</h3>
        <p>{t('cookies.description')}</p>
        <div className="cookie-buttons">
          <button onClick={handleAccept} className="accept-button">
            {t('cookies.accept')}
          </button>
          <button onClick={handleDecline} className="decline-button">
            {t('cookies.decline')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
